module.exports = __webpack_public_path__ + "static/media/master.b05390ef.jpg";